import styled, { css } from "styled-components"
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from "styled-system"

import { ThemeProps } from "src/legacy/theme"
import {
  aspectRatio,
  AspectRatioProps,
  cursor,
  CursorProps,
  gridColumnEnd,
  GridColumnEndProps,
  gridColumnStart,
  GridColumnStartProps,
  objectFit,
  ObjectFitProps,
  textDecoration,
  TextDecorationProps,
  textTransform,
  TextTransformProps,
  transform,
  TransformProps,
  transition,
  TransitionProps,
  whiteSpace,
  WhiteSpaceProps,
} from "../customStyleProps"

import rawHtmlCss from "./rawHtmlCss"

interface OwnProps {
  theme?: ThemeProps
}

export type ElementProps = OwnProps &
  React.HTMLAttributes<HTMLElement> &
  AspectRatioProps &
  BackgroundProps &
  BorderProps &
  ColorProps &
  CursorProps &
  FlexboxProps &
  GridProps &
  GridColumnEndProps &
  GridColumnStartProps &
  LayoutProps &
  ObjectFitProps &
  PositionProps &
  ShadowProps &
  SpaceProps &
  TextDecorationProps &
  TextTransformProps &
  TransitionProps &
  TransformProps &
  TypographyProps &
  WhiteSpaceProps

export const elementCss = css`
  box-sizing: border-box;

  ${aspectRatio}
  ${background};
  ${border};
  ${color};
  ${cursor};
  ${flexbox};
  ${grid};
  ${gridColumnEnd};
  ${gridColumnStart};
  ${layout};
  ${objectFit};
  ${position};
  ${shadow};
  ${space};
  ${textDecoration};
  ${textTransform};
  ${transform}
  ${transition};
  ${typography};
  ${whiteSpace};
`
const Element = styled.div<ElementProps>`
  ${elementCss};
  ${props => (props.dangerouslySetInnerHTML ? rawHtmlCss : null)};
`

export default Element
